import React, {useState, useEffect} from 'react'
import styles from './styles.module.scss'
import branchApi from "../../store/branchStore/branchApi";
import {Roles} from "../../config";
import Checkbox from "../../components/FormElements/Checkbox";
import ButtonFilled from "../../components/FormElements/ButtonFilled";
import FailedNotificationLine from "../../components/FailedNotificationLine";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {useCurrentBranch} from "../../hooks/useCurrentBranch";
import { store } from "react-notifications-component";
import {useHistory, useRouteMatch} from "react-router-dom";
import { format } from 'date-fns';

const categories = [
  {
    name: 'promising',
    category: 'EMERGING_CUSTOMERS'
  },
  {
    name: 'NSAnalysis.important',
    category: 'TOP_CUSTOMERS'
  },
  {
    name: 'active',
    category: 'ACTIVE_CUSTOMERS'
  },
  {
    name: 'fickle',
    category: 'UNSTEADY_CUSTOMERS'
  },
  {
    name: 'NSAnalysis.zone',
    category: 'POTENTIAL_LOST_CUSTOMERS'
  },
  {
    name: 'lost',
    category: 'LOST_CUSTOMERS'
  },
  {
    name: 'inactive',
    category: 'INACTIVE_CUSTOMERS'
  },
]

const RFMSendNotification = (props) => {
  const { info } = useSelector(s => s.branchReducer);
  const { params } = useRouteMatch();
  const clientType = params.clientType.toUpperCase();
  const rfm = useSelector(s => s.RFMReducer);
  const [stateClientType, setStateClientType] = useState(clientType)

  const history = useHistory()
  const { t } = useTranslation();
  const [modalPending, setModalPending] = useState(false);
  const [pushMessage, setPushMessage] = useState('')
  const [disableAutonotificationStatus, setDisableAutonotificationStatus] = useState(false);
  const [historyOfNotifications, setHistoryOfNotifications] = useState([])
  const { currentRole, currentBranch, groupId } = useCurrentBranch();
  const [activeIndexBranch, setActiveIndexBranch] = useState(0)
  const [branchIds, setBranchIds] = useState([]);

  const onChangePushMessage = (e) => {
    if (e.target.value.length <= 1200) {
      setPushMessage(e.target.value);
    }
  }

  const onDisableAutoNotification = () => {
    if (!info) return

    setDisableAutonotificationStatus(true);
    branchApi.branchesSendPushCustomersStop(info.id)
      .then((res) => {
        store.addNotification({
          title: t('success'),
          message: 'Рассылка успешно остановлена',
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 5000,
            onScreen: true
          }
        });
      })
      .finally(() => {
        setDisableAutonotificationStatus(false);
      });
  }

  const onDisableAllAutoNotification = () => {
    if (!info) return

    setDisableAutonotificationStatus(true);
    branchApi.branchesBranchCustomersUploadedStopAll(info.id)
      .then((res) => {
        store.addNotification({
          title: t('success'),
          message: 'Рассылки успешно остановлены',
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 5000,
            onScreen: true
          }
        });
      })
      .finally(() => {
        setDisableAutonotificationStatus(false);
      });
  }

  const onSendWhatsappToCustomers = () => {
    if (!info || !pushMessage || !rfm[stateClientType].length) return

    setModalPending(true);
    const user_ids = rfm[stateClientType].map((i) => i.id);
    branchApi.sendPushToCustomers(info.id, {user_ids, message: pushMessage, message_channel: 'whatsapp', source: 'rfm'})
      .then((res) => {
        store.addNotification({
          title: t('success'),
          message: t('successMessageSent'),
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 5000,
            onScreen: true
          }
        });
        setPushMessage('');
      })
      .finally(() => {
        setModalPending(false);
      });
  }

  const calculateHistoryCount = () => {
    if (historyOfNotifications && historyOfNotifications.length) {
      let countsOfBranches = 0

      historyOfNotifications.forEach((item) => {
        if (item.history && item.history.length) {
          item.history.forEach((historyItem, index) => {
            if (historyItem.sent_count) {
              countsOfBranches += historyItem.sent_count
            }
          })
        }
      })

      return countsOfBranches
    }

    return 0
  }

  const calculateHistoryItemCount = (history = []) => {
    if (history && history.length) {
      let countsOfBranch = 0

      history.forEach((historyItem) => {
        if (historyItem.sent_count) {
          countsOfBranch += historyItem.sent_count
        }
      })

      return countsOfBranch
    }

    return 0
  }

  const renderDate = (item) => {
    if (item.history && item.history.length) {
      if (item.history[item.history.length - 1].last_date) {
        return new Intl.DateTimeFormat('ru-RU',
          { year: 'numeric', month: 'numeric', day: 'numeric' }
        ).format(history.last_date)
      }
    }


    return ''
  }

  useEffect(() => {
    let intervalId = null
    if (info?.id) {
      branchApi.branchesSendPushCustomersUploadedHistory(info.id)
        .then((response) => {
          setHistoryOfNotifications(response?.data || null)
        })

      intervalId = setInterval(() => {
        branchApi.branchesSendPushCustomersUploadedHistory(info.id)
          .then((response) => {
            setHistoryOfNotifications(response?.data || null)
          })
      }, 10000)
    }

    return () => {
      intervalId && clearInterval(intervalId)
    }
  }, [info?.branch_id]);

  const showStatus = (item) => {
    if (!item.history || !item.history.length) return null
    return item.history[item.history.length - 1].status === 'IN_PROGRESS' ? styles.active : styles.passive
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.leftContent}>
          <div className={styles.modalContainer}>
            <i
              className="fa fa-chevron-left"
              aria-hidden="true"
              style={{cursor: 'pointer'}}
              onClick={() => history.push(`/analytics/rfm/${clientType}`)}
            />
            <div className={styles.header}>
              <p>{t('NSClients.not')}</p>
            </div>
            <div>
              <p className={styles.p}>{t('NSClients.textNot')}</p>
              <textarea
                placeholder={t('Form.enterText')}
                className={styles.textArea}
                value={pushMessage}
                onChange={onChangePushMessage}
                required
              />
              <div className={styles.span}
                   style={{color: `${pushMessage.length >= 624 ? 'tomato' : '#000000'}`}}>
                {t('maxSym', {sym: 1200})}
              </div>

              <div style={{display: 'flex', gap: 8, flexDirection: 'column', marginTop: '16px'}}>
                <ButtonFilled
                  className={styles.stopBtn}
                  variant="red"
                  onClick={onDisableAutoNotification}
                  loading={modalPending || disableAutonotificationStatus}
                >
                  Остановить рассылку
                </ButtonFilled>
                <ButtonFilled
                  className={styles.btn}
                  onClick={onSendWhatsappToCustomers}
                  disabled={!rfm?.[stateClientType]?.length || !pushMessage}
                  loading={modalPending || disableAutonotificationStatus}
                >
                  {t('send')}
                </ButtonFilled>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.rightContent}>
          {/*<p>Общее кол-во отправок - {calculateHistoryCount()}</p>*/}

          <ul className={styles.history}>
            <li>
              <p>
              </p>
              <p>{t('NSCrossMarketing.cat')}</p>
            </li>
            {categories.map((category) => (
              <li
                key={category.category}
                className={`${showStatus(historyOfNotifications)} ${stateClientType === category.category ? styles.chosen : ''}`}
              >
                <p onClick={(e) => e.stopPropagation()}>
                  <Checkbox
                    onClick={() => setStateClientType(category.category)}
                    name={category.category}
                    checked={stateClientType === category.category}
                  />
                </p>
                <p>
                  <span>{t(category.name)}</span>
                </p>
                {/*<p>*/}
                {/*  {renderDate(history)}*/}
                {/*</p>*/}
                <p>
                  <span style={{ whiteSpace: 'nowrap', fontSize: 12, color: 'gray' }}>
                    Количество клиентов: {rfm?.[category.category]?.length || 0}
                    {/*{calculateHistoryItemCount(history?.history || [])}*/}
                  </span>
                </p>
                <p></p>
              </li>
            ))}
          </ul>
          <ButtonFilled
            className={styles.stopBtn}
            onClick={onDisableAllAutoNotification}
            variant="red"
            loading={modalPending || disableAutonotificationStatus}
          >
            Остановить все рассылки
          </ButtonFilled>
        </div>
      </div>

      <div className={styles.historyOfNotifications}>
        <p style={{ margin: 0 }}>История рассылок</p>

        {historyOfNotifications?.history?.length ? [...historyOfNotifications.history].reverse().map((historyItem, index) => (
          <div className={styles.historyItem} key={index}>
            <div className={styles.historyTop}>
              <div>{format(new Date(historyItem.last_date), 'dd.MM.yyyy')}</div>
            </div>
            <div className={styles.historyCenter}>
              {historyItem.message}
            </div>
            <div className={styles.historyBottom}>
              <div>{historyItem.sent_count}</div>
              {historyItem.completed_date ? (
                <div>{format(new Date(historyItem.completed_date), 'dd.MM.yyyy')}</div>
              ) : null}
            </div>
            <FailedNotificationLine item={historyItem} />
          </div>
        )) : null}
      </div>
    </div>
  )
}

export default RFMSendNotification